export const PAGE_PATH = '/admin-popup';
